


































import { defineComponent, computed } from "@vue/composition-api";

export default defineComponent({
	emits: ["input"],
	props: {
		value: {
			type: Boolean,
			default: true,
		},
	},
	setup(props, context) {
		const val = computed({
			get() {
				return props.value;
			},
			set(v) {
				context.emit("input", v);
			},
		});

		const label = computed(() => {
			return props.value ? "YES" : "NO";
		})

		

		const options = computed(() => {
			return [
				{ value: false, text: "NO" },
				{ value: true, text: "YES" },
			];
		});

		const toggleValue = () => {
			val.value = !val.value;
		}

		return {
			val,
			options,
			label,
			toggleValue,
		};
	},
});
